"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Web3 = require("web3");
var Observable_1 = require("rxjs/Observable");
var Subject_1 = require("rxjs/Subject");
require("rxjs/add/observable/combineLatest");
require("rxjs/add/observable/empty");
require("rxjs/add/observable/fromPromise");
require("rxjs/add/observable/interval");
require("rxjs/add/observable/merge");
require("rxjs/add/observable/of");
require("rxjs/add/operator/combineLatest");
require("rxjs/add/operator/debounceTime");
require("rxjs/add/operator/distinctUntilChanged");
require("rxjs/add/operator/do");
require("rxjs/add/operator/filter");
require("rxjs/add/operator/map");
require("rxjs/add/operator/mergeMap");
require("rxjs/add/operator/share");
require("rxjs/add/operator/startWith");
require("rxjs/add/operator/take");
var bet_token_config_1 = require("./bet-token.config");
exports.BET_TOKEN_ADDRESS = new core_1.InjectionToken('BET_TOKEN_ADDRESS');
exports.BET_TOKEN_NETWORK = new core_1.InjectionToken('BET_TOKEN_NETWORK');
var BetTokenService = /** @class */ (function () {
    function BetTokenService(betTokenAddress, betTokenNetwork) {
        var _this = this;
        this.betTokenAddress = betTokenAddress;
        this.betTokenNetwork = betTokenNetwork;
        this._connectedChange = new Subject_1.Subject();
        this.connectedChange$ = this._connectedChange.distinctUntilChanged().share();
        this._connected = undefined;
        this.events$ = new Subject_1.Subject();
        this.newSend$ = new Subject_1.Subject();
        this.initWeb3();
        this.defaultTimer$ = Observable_1.Observable
            .interval(100)
            .startWith(undefined)
            .mergeMap(function () { return _this.getBlockNumber(); })
            .distinctUntilChanged()
            .share();
        this.checkData()
            .filter(function () { return window.web3 && window.web3.currentProvider; })
            .take(1)
            .subscribe(function () { return _this.initWeb3(); });
        this.connectedChange$
            .filter(function (status) { return status === 'total'; })
            .mergeMap(function () { return _this.getAccount(); })
            .subscribe(function (account) {
            _this.web3.eth.defaultAccount = account;
        });
        this.checkData()
            .mergeMap(function () { return _this.getAccount(true); })
            .distinctUntilChanged()
            .combineLatest(this.isNetwork().startWith(true), this.getEthBalanceChanges().startWith(Infinity))
            .subscribe(function (_a) {
            var account = _a[0], isNetwork = _a[1], balance = _a[2];
            switch (account) {
                case undefined:
                    _this._connected = 'no-provider';
                    break;
                case '':
                    _this._connected = 'no-account';
                    break;
                default: {
                    _this._connected = 'total';
                    if (!balance) {
                        _this._connected = 'no-ether';
                    }
                    if (!isNetwork) {
                        _this._connected = 'no-network';
                    }
                }
            }
            _this._connectedChange.next(_this._connected);
        });
    }
    Object.defineProperty(BetTokenService.prototype, "connected", {
        get: function () {
            return this._connected;
        },
        enumerable: true,
        configurable: true
    });
    BetTokenService.prototype.initWeb3 = function () {
        if (!this.web3 && window.web3) {
            this.web3 = new Web3(window.web3.currentProvider);
        }
    };
    BetTokenService.prototype.getBlockNumber = function () {
        if (this.web3) {
            return Observable_1.Observable.fromPromise(this.web3.eth.getBlockNumber());
        }
        return Observable_1.Observable.empty();
    };
    BetTokenService.prototype.getNetwork = function () {
        if (this.web3) {
            return Observable_1.Observable.fromPromise(this.web3.eth.net.getNetworkType());
        }
        return Observable_1.Observable.empty();
    };
    BetTokenService.prototype.isNetwork = function () {
        var _this = this;
        return this.getNetwork()
            .map(function (network) { return network === _this.betTokenNetwork; });
    };
    BetTokenService.prototype.getRawContract = function () {
        if (!this.web3) {
            return;
        }
        if (!this.contract) {
            this.contract = new this.web3.eth.Contract(bet_token_config_1.betTokenInterface, this.betTokenAddress);
        }
        return this.contract;
    };
    BetTokenService.prototype.getContract = function () {
        var _this = this;
        return this.isNetwork()
            .mergeMap(function (isNetwork) {
            if (!isNetwork) {
                return Observable_1.Observable.empty();
            }
            var contract = _this.getRawContract();
            if (!contract) {
                return Observable_1.Observable.empty();
            }
            return Observable_1.Observable.of(contract);
        });
    };
    BetTokenService.prototype.getAccount = function (allowNoAccount) {
        if (allowNoAccount === void 0) { allowNoAccount = false; }
        if (!this.web3) {
            return Observable_1.Observable.of(undefined);
        }
        return Observable_1.Observable
            .fromPromise(this.web3.eth.getAccounts())
            .map(function (accounts) { return accounts[0] || ''; })
            .filter(function (account) { return !!account || allowNoAccount; });
    };
    BetTokenService.prototype.getEthBalance = function () {
        var _this = this;
        if (!this.web3) {
            return Observable_1.Observable.of(undefined);
        }
        return this.getAccount()
            .mergeMap(function (account) {
            return Observable_1.Observable.fromPromise(_this.web3.eth.getBalance(account));
        })
            .map(function (balance) { return +_this.web3.utils.fromWei(balance, 'ether'); });
    };
    BetTokenService.prototype.getPendingTransactions = function () {
        var _this = this;
        return this.getAccount()
            .mergeMap(function (account) {
            return Observable_1.Observable.fromPromise(_this.web3.eth.getBlock('pending', true))
                .map(function (_a) {
                var transactions = _a.transactions;
                return transactions.filter(function (transaction) { return transaction.from === account; });
            });
        });
    };
    BetTokenService.prototype.getToken = function () {
        return this.getContract()
            .mergeMap(function (contract) {
            return Observable_1.Observable
                .combineLatest(Observable_1.Observable.fromPromise(contract.methods.name().call()), Observable_1.Observable.fromPromise(contract.methods.symbol().call()), Observable_1.Observable.fromPromise(contract.methods.decimals().call()), Observable_1.Observable.fromPromise(contract.methods.version().call()), Observable_1.Observable.fromPromise(contract.methods.owner().call()), Observable_1.Observable.fromPromise(contract.methods.totalSupply().call()))
                .map(function (_a) {
                var name = _a[0], symbol = _a[1], decimals = _a[2], version = _a[3], owner = _a[4], totalSupply = _a[5];
                return ({ name: name, symbol: symbol, decimals: decimals, version: version, owner: owner, totalSupply: totalSupply });
            });
        });
    };
    BetTokenService.prototype.getBalance = function () {
        return this.getAccount()
            .combineLatest(this.getContract())
            .mergeMap(function (_a) {
            var account = _a[0], contract = _a[1];
            return Observable_1.Observable.fromPromise(contract.methods.balanceOf(account).call());
        })
            .map(function (number) { return +number; });
    };
    BetTokenService.prototype.getAvailableBalance = function () {
        return this.getAccount()
            .combineLatest(this.getContract())
            .mergeMap(function (_a) {
            var account = _a[0], contract = _a[1];
            return Observable_1.Observable.fromPromise(contract.methods.availableBalanceOf(account).call());
        })
            .map(function (number) { return +number; });
    };
    BetTokenService.prototype.getDebt = function () {
        return this.getAccount()
            .combineLatest(this.getContract())
            .mergeMap(function (_a) {
            var account = _a[0], contract = _a[1];
            return Observable_1.Observable.fromPromise(contract.methods.debtOf(account).call());
        })
            .map(function (number) { return +number; });
    };
    BetTokenService.prototype.getMyTransfers = function () {
        return this.getAccount()
            .combineLatest(this.getContract())
            .mergeMap(function (_a) {
            var account = _a[0], contract = _a[1];
            return Observable_1.Observable.fromPromise(contract.getPastEvents('Transfer', { fromBlock: 0, toBlock: 'latest' }))
                .map(function (transfers) {
                return transfers
                    .map(function (_a) {
                    var transactionHash = _a.transactionHash, returnValues = _a.returnValues;
                    return ({
                        tx: transactionHash,
                        from: String(returnValues._from),
                        to: String(returnValues._to),
                        value: +returnValues._value,
                    });
                })
                    .filter(function (_a) {
                    var from = _a.from, to = _a.to;
                    return from === account || to === account;
                });
            });
        });
    };
    BetTokenService.prototype.dripToMe = function () {
        var _this = this;
        return this.getAccount()
            .combineLatest(this.getContract())
            .do(function () { return _this.newSend$.next(); })
            .mergeMap(function (_a) {
            var from = _a[0], contract = _a[1];
            return Observable_1.Observable.fromPromise(contract.methods.dripToMe().send({ from: from }));
        })
            .do(function (_a) {
            var events = _a.events;
            return _this.onEvents(events);
        });
    };
    BetTokenService.prototype.transfer = function (to, amount) {
        var _this = this;
        return this.getAccount()
            .combineLatest(this.getContract())
            .do(function () { return _this.newSend$.next(); })
            .mergeMap(function (_a) {
            var from = _a[0], contract = _a[1];
            return Observable_1.Observable.fromPromise(contract.methods.transfer(to, amount).send({ from: from }));
        })
            .do(function (_a) {
            var events = _a.events;
            return _this.onEvents(events);
        });
    };
    BetTokenService.prototype.createBet = function (against, amount, bet) {
        var _this = this;
        return this.getAccount()
            .combineLatest(this.getContract())
            .do(function () { return _this.newSend$.next(); })
            .mergeMap(function (_a) {
            var from = _a[0], contract = _a[1];
            return Observable_1.Observable.fromPromise(contract.methods.bet(against, amount, bet).send({ from: from }));
        })
            .do(function (_a) {
            var events = _a.events;
            return _this.onEvents(events);
        });
    };
    BetTokenService.prototype.acceptBet = function (bet, accept) {
        var _this = this;
        return this.getAccount()
            .combineLatest(this.getContract())
            .do(function () { return _this.newSend$.next(); })
            .mergeMap(function (_a) {
            var from = _a[0], contract = _a[1];
            return Observable_1.Observable.fromPromise(contract.methods.acceptBet(bet, accept).send({ from: from }));
        })
            .do(function (_a) {
            var events = _a.events;
            return _this.onEvents(events);
        });
    };
    BetTokenService.prototype.cryAndForgotBet = function (bet) {
        var _this = this;
        return this.getAccount()
            .combineLatest(this.getContract())
            .do(function () { return _this.newSend$.next(); })
            .mergeMap(function (_a) {
            var from = _a[0], contract = _a[1];
            return Observable_1.Observable.fromPromise(contract.methods.cryAndForgotBet(bet).send({ from: from }));
        })
            .do(function (_a) {
            var events = _a.events;
            return _this.onEvents(events);
        });
    };
    BetTokenService.prototype.giveMeTheMoney = function (bet) {
        var _this = this;
        return this.getAccount()
            .combineLatest(this.getContract())
            .do(function () { return _this.newSend$.next(); })
            .mergeMap(function (_a) {
            var from = _a[0], contract = _a[1];
            return Observable_1.Observable.fromPromise(contract.methods.giveMeTheMoney(bet).send({ from: from }));
        })
            .do(function (_a) {
            var events = _a.events;
            return _this.onEvents(events);
        });
    };
    BetTokenService.prototype.getBetSize = function () {
        return this.getContract()
            .mergeMap(function (contract) {
            return Observable_1.Observable.fromPromise(contract.methods.betsSize().call());
        })
            .map(function (size) { return +size; });
    };
    BetTokenService.prototype.getMyBets = function () {
        var _this = this;
        return this.getAccount()
            .mergeMap(function (account) {
            if (account === void 0) { account = ''; }
            return _this.getBets()
                .map(function (bets) { return bets
                .filter(function (_a) {
                var from = _a.from, against = _a.against;
                return from.toLowerCase() === account.toLowerCase() || against.toLowerCase() === account.toLowerCase();
            }); });
        });
    };
    BetTokenService.prototype.getBets = function () {
        return this.getAllBets()
            .map(function (bets) { return bets.filter(function (bet) { return bet.opened; }); });
    };
    BetTokenService.prototype.getAllBets = function () {
        var _this = this;
        return this.getBetSize()
            .mergeMap(function (size) {
            return Observable_1.Observable
                .combineLatest.apply(Observable_1.Observable, Array.from(new Array(size))
                .map(function (_, index) { return _this.getBet(index); }));
        });
    };
    BetTokenService.prototype.getBet = function (bet) {
        return this.getContract()
            .mergeMap(function (contract) {
            return Observable_1.Observable.fromPromise(contract.methods.bets(bet).call());
        })
            .map(function (_) { return (__assign({ id: bet }, _, { amount: +_.amount })); });
    };
    BetTokenService.prototype.onEvents = function (events) {
        var _this = this;
        Object.entries(events)
            .map(function (_a) {
            var event = _a[0], response = _a[1];
            return ({ event: event, response: response });
        })
            .forEach(function (event) { return _this.events$.next(event); });
    };
    BetTokenService.prototype.checkData = function () {
        var _this = this;
        var types = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            types[_i] = arguments[_i];
        }
        // TODO: wait until MetaMask events support
        var triggers = [];
        triggers.push(this.defaultTimer$);
        triggers.push(Observable_1.Observable.interval(100)
            .mergeMap(function () { return _this.getAccount(); })
            .distinctUntilChanged());
        types
            .map(function (type) {
            switch (type) {
                case 'send': return _this.newSend$;
                case 'bet': return _this.events$.filter(function (_a) {
                    var event = _a.event;
                    return event === 'UpdateBet';
                });
                case 'transaction': return _this.events$.filter(function (_a) {
                    var event = _a.event;
                    return event === 'Transfer';
                });
                default: return Observable_1.Observable.empty();
            }
        })
            .forEach(function (observable) { return triggers.push(observable); });
        return Observable_1.Observable.merge.apply(Observable_1.Observable, triggers).debounceTime(100);
    };
    BetTokenService.prototype.getAccountChanges = function () {
        var _this = this;
        return this.checkData()
            .mergeMap(function () { return _this.getAccount(); })
            .distinctUntilChanged();
    };
    BetTokenService.prototype.getEthBalanceChanges = function () {
        var _this = this;
        return this.checkData('bet', 'transaction')
            .mergeMap(function () { return _this.getEthBalance(); })
            .distinctUntilChanged();
    };
    BetTokenService.prototype.getMyBetsChanges = function () {
        var _this = this;
        return this.checkData('bet')
            .mergeMap(function () { return _this.getMyBets(); })
            .distinctUntilChanged(function (a, b) { return JSON.stringify(a) === JSON.stringify(b); });
    };
    BetTokenService.prototype.getBalanceChanges = function () {
        var _this = this;
        return this.checkData('transaction')
            .mergeMap(function () { return _this.getBalance(); })
            .distinctUntilChanged();
    };
    BetTokenService.prototype.getAvailableBalanceChanges = function () {
        var _this = this;
        return this.checkData('bet', 'transaction')
            .mergeMap(function () { return _this.getAvailableBalance(); })
            .distinctUntilChanged();
    };
    BetTokenService.prototype.getDebtChanges = function () {
        var _this = this;
        return this.checkData('bet', 'transaction')
            .mergeMap(function () { return _this.getDebt(); })
            .distinctUntilChanged();
    };
    BetTokenService.prototype.getMyTransfersChanges = function () {
        var _this = this;
        return this.checkData()
            .mergeMap(function () { return _this.getMyTransfers(); })
            .distinctUntilChanged(function (a, b) { return JSON.stringify(a) === JSON.stringify(b); });
    };
    BetTokenService.prototype.getPendingTransactionsChanges = function () {
        var _this = this;
        var hash = function (transactions) { return transactions.map(function (_) { return _.hash; }).sort().join(','); };
        return this.checkData('send', 'bet', 'transaction')
            .mergeMap(function () { return _this.getPendingTransactions(); })
            .distinctUntilChanged(function (a, b) { return hash(a) === hash(b); });
    };
    return BetTokenService;
}());
exports.BetTokenService = BetTokenService;



// WEBPACK FOOTER //
// /home/travis/build/Pedro-vk/Bet-Token-wallet/src/app/shared/bet-token.service.ts.pre-build-optimizer.js